export const OPEN_DIALOG_MODIFIED_EMAILS = "OPEN_DIALOG_MODIFIED_EMAILS";

export const CLOSE_DIALOG_MODIFIED_EMAILS = "CLOSE_DIALOG_MODIFIED_EMAILS";

export const ON_GET_LOGS_ERROR = "ON_GET_LOGS_ERROR";

export const ON_EXPAND_TABLE = "ON_EXPAND_TABLE";

export const SET_SEARCH = "SET_SEARCH";

export const RESET_EXPANDED_ITEM = "RESET_EXPANDED_ITEM";